// extracted by mini-css-extract-plugin
export var container = "_ew-0";
export var content = "_ew-3";
export var customerTitle = "_ew-4";
export var empty = "_ew-5";
export var gray = "_ew-6";
export var header = "_ew-7";
export var info = "_ew-8";
export var loading = "_ew-2";
export var loadingCard = "_ew-9";
export var oneLine = "_ew-a";
export var personName = "_ew-e";
export var pillContainer = "_ew-b";
export var selected = "_ew-1";
export var text = "_ew-c";
export var twoLines = "_ew-d";
export var unread = "_ew-f";
export var unreadIndicator = "_ew-g";